import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { useRecoilState } from "recoil";
import { LoginState } from "./global/LoginState";
import DashboardRoutes from "./routes/DashboardRoutes";
import LandingRoutes from "./routes/LandingRoutes";
import Alert from "./utils/Alert";
import Loader from "./utils/Loader";
import Tostify from "./utils/Tostify";

function App() {
  const [loginState] = useRecoilState(LoginState);

  return (
    <BrowserRouter>
      <Suspense>
        <Loader />
        <Alert />
        {loginState ? <DashboardRoutes /> : <LandingRoutes />}
        <Tostify />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
